import React, { useState, useEffect } from 'react'
import Modal from 'react-responsive-modal'
import { toastr } from 'react-redux-toastr'
import { messagesService } from '../../_services/messages.service'
import ReactSelect from 'react-select'
import { AiOutlineLoading, AiOutlineSave } from "react-icons/ai"
import { Formik, Field, getIn, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import ErrorPopUp from '../Shared/ErrorPopUp'
import NumberFormat from 'react-number-format'
import messageTypes from '../../_constants/messageTypes'
import config from '../../config'
import Lightbox from "rhino-react-image-lightbox-rotate";
import moment from 'moment-jalaali'
import DatePicker from '../Shared/DatePicker'

// import "react-lightbox-component/build/css/index.css";

moment.loadPersian({ dialect: 'persian-modern' })


const MessageModal = (props) => {

  const [loading, setLoading] = useState(false)
  const [data, setData] = useState(props.data)
  const [open, setOpen] = useState(props.open)
  const [isOpen, setIsOpen] = useState(false)
  const [photoIndex, setPhotoIndex] = useState(0)

  useEffect(() => {
    setOpen(props.open)
    setData(props.data)
  }, [props.open, props.data])

  const handleSubmit = (values, setSubmitting) => {

    setLoading(true)

    if (values.id) {

      messagesService.edit(values.id, JSON.stringify(values))
        .then((res) => {

          toastr.success('ویرایش پیام', 'پیام "' + values.title + '" با موفقیت ویرایش شد');
          setLoading(false);
          props.handleModalCloseAndReload();
          setSubmitting(false);

        })
        .catch((error) => {
          // console.log(error);
          setLoading(false);
          setSubmitting(false);
          toastr.error('مشکلی پیش آمد. لطفا دوباره سعی کنید.');
        });

    } else {

      messagesService.add(JSON.stringify(values))
        .then((res) => {

          toastr.success('ثبت پیام جدید', 'پیام "' + res.data.title + '" با موفقیت ثبت شد');
          setLoading(false);
          props.handleModalCloseAndReload();
          setSubmitting(false);

        })
        .catch((error) => {
          // console.log(error);
          setLoading(false);
          setSubmitting(false);
          toastr.error('مشکلی پیش آمد. لطفا دوباره سعی کنید.');
        });

    }

  }

  const customStyles = {
    control: (provided) => ({
      ...provided,
      background: '#f6f6f6',
      borderRadius: 20,
      boxShadow: 'none',
      border: 'none',
      paddingRight: '12',
    }),
    indicatorSeparator: () => ({
      display: 'none'
    }),

  }

  const ValidationSchema = Yup.object().shape({

    title: Yup.string().nullable().trim().required('عنوان پیام'),
    text: Yup.string().nullable().trim().required('متن پیام'),
    messageType: Yup.string().nullable().trim().required('نوع ارسال'),
    startDate: Yup.string().nullable().trim().required('تاریخ شروع نمایش'),

  });

  return (
    <Modal open={open} onClose={props.handleModalClose()} center
      classNames={{
        overlay: "customOverlay",
        modal: "customModal lg",
        closeButton: "customModalCloseButton",
      }}>

      <Formik
        enableReinitialize
        initialValues={data}
        onSubmit={(values, { setSubmitting }) => {
          // // console.log(values);
          handleSubmit(values, setSubmitting)
        }}
        validationSchema={ValidationSchema}
      >
        {props => {
          const {
            values,
            touched,
            errors,
            isSubmitting,
            handleChange,
            handleBlur,
            setFieldValue,
            handleSubmit,
          } = props;
          return (

            <form onSubmit={handleSubmit}>
              <div className="row" style={{ position: "relative" }}>
                <div className="col-md-12 message-details-modal">

                  <fieldset className="fieldset">
                    <legend>
                      {data && data.id ? 'ویرایش پیام' : 'ارسال پیام جدید'}
                    </legend>

                    <div className="row">
                      <div className="form-inline">

                        <div className="col-md-12">
                          <label>عنوان پیام</label>
                          <Field type="text"
                            value={values.title}
                            onBlur={handleBlur}
                            name="title"
                            autoFocus
                            className={getIn(touched, "title") ? getIn(errors, "title") ? "text-input has-error" : "text-input" : "text-input has-error"}
                          />
                          <ErrorMessage component={ErrorPopUp} name="title" />
                        </div>

                        <div className="col-md-12">
                          <label>متن پیام</label>
                          <Field name="text" rows="12"
                            render={({ field }) =>
                              <textarea {...field}
                                value={values.text}
                                className={getIn(touched, "text") ? getIn(errors, "text") ? "textarea rtl has-error" : "textarea rtl" : "textarea rtl has-error"}
                              />}
                          />
                          <ErrorMessage component={ErrorPopUp} name="text" />
                        </div>
                        {/* {!values.userId && */}
                        <div className="col-md-6">
                          <label>تاریخ شروع نمایش</label>
                          <DatePicker
                            clearable
                            defaultValue={values.startDate}
                            onChange={val => {
                              setFieldValue("startDate", val)
                            }}
                          />
                          <ErrorMessage component={ErrorPopUp} name="startDate" />
                        </div>
                        {/* } */}
                        {!values.userId && values.messageType !== 3 ? 
                          <div className="col-md-6">
                            <label>تاریخ اتمام نمایش</label>
                            <DatePicker
                              clearable
                              defaultValue={values.endDate}
                              minDate={values.startDate}
                              onChange={val => {
                                setFieldValue("endDate", val)
                              }}
                            />
                            <ErrorMessage component={ErrorPopUp} name="endDate" />
                          </div>
                          :
                          <div className="clearfix"></div>
                        }
                        {values && values.messageType === 3 ?
                          <div className="col-md-6">
                            <br/>
                            <label>نوع ارسال: ارسال خصوصی</label>
                          </div>
                          :
                          <div className="col-md-6">
                            <label>نوع ارسال</label>
                            <ReactSelect
                              name="messageType"
                              placeholder=""
                              styles={customStyles}
                              value={messageTypes.filter(el => el.value === values.messageType)[0] || null}
                              options={messageTypes.filter(el => el.value != 3)}
                              onChange={(val) => {
                                setFieldValue('messageType', val.value);
                              }}
                            />
                            <ErrorPopUp error={errors.messageType} touched={touched.messageType} style={{ top: -4, left: 15, right: 'auto' }} />
                          </div>
                        }

                        <div className="col-md-12">
                          <br />
                          <button type="submit" className={"icon button submit-btn " + (isSubmitting ? "isSubmitting" : "")} disabled={isSubmitting}
                            onClick={(e) => { e.preventDefault(); handleSubmit() }}
                          >
                            {isSubmitting ?
                              <AiOutlineLoading className="mdi-spin" size="22px" />
                              :
                              <AiOutlineSave size="22px" />
                            }ذخیره</button>
                        </div>

                      </div>
                    </div>

                  </fieldset>

                </div>
              </div>

            </form>

          );
        }}
      </Formik>
    </Modal>

  )
}

export default MessageModal;